import {
  FormGridItem,
  type FormGridItemProps,
  MenuItem,
  Select,
  type SelectProps,
  useSelectValidator,
} from '@ace-clublabs/shared-component-library';

import { getRequiredFieldSx } from '../utils';

export interface ExpectedTravelTimeFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<SelectProps>;
  validatorProps?: Parameters<typeof useSelectValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

const DEFAULT_WHEN_DO_YOU_PLAN_TO_TRAVEL = '0-3 Months';

const selectMenuProps: SelectProps['MenuProps'] = {
  sx: {
    '& .MuiMenu-paper': {
      maxHeight: {
        xs: 51 * 3,
        lg: 51 * 4,
      },
    },
  },
  PaperProps: { className: 'MuiSelect-Menu-paper' },
};

export const ExpectedTravelTimeField: React.FC<
  ExpectedTravelTimeFieldProps
> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'When do you plan to travel';

  const validator = useSelectValidator({
    label,
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={{ xs: 12, lg: 6 }}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <Select
        label={label}
        defaultValue={DEFAULT_WHEN_DO_YOU_PLAN_TO_TRAVEL}
        fullScreenThreshold={7}
        onChange={(e) => onChange(e.target.value as string)}
        value={value}
        name='expectedTravelTime'
        fullWidth={true}
        data-testid='expectedTravelTime'
        MenuProps={selectMenuProps}
        validator={validator}
        {...fieldProps}
      >
        {[
          DEFAULT_WHEN_DO_YOU_PLAN_TO_TRAVEL,
          '3-6 Months',
          '6-9 Months',
          '9-12 Months',
          '12+ Months',
          'Not Sure',
        ].map((travelTime) => (
          <MenuItem key={travelTime} value={travelTime}>
            {travelTime}
          </MenuItem>
        ))}
      </Select>
    </FormGridItem>
  );
};
